<template>
    <div class="managing-cover">
        <img src="~@managing/assets/cover.jpg" />

        <h3 style="margin-top: -16px">Администрирование</h3>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
